/**
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.org) All Rights Reserved.
 *
 * WSO2 Inc. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

export const INIT = "init";
export const SIGN_IN = "sign-in";
export const AUTH_CODE = "auth-code";
export const SIGN_OUT = "sign-out";
export const HTTP_REQUEST = "http-request";
export const HTTP_REQUEST_ALL = "http-request-all";
export const REQUEST_CUSTOM_GRANT = "request-custom-grant";
export const REVOKE_ACCESS_TOKEN = "revoke-access-token";
export const END_USER_SESSION = "end-user-session";
export const REQUEST_START = "request-start";
export const REQUEST_SUCCESS = "request-success";
export const REQUEST_ERROR = "request-error";
export const REQUEST_FINISH = "request-finish";
export const GET_OIDC_SERVICE_ENDPOINTS = "get-oidc-service-endpoints";
export const GET_BASIC_USER_INFO = "get-basic-user-info";
export const GET_DECODED_ID_TOKEN = "get-decoded-id-token";
export const GET_DECODED_IDP_ID_TOKEN = "get-decoded-idp-id-token";
export const GET_CRYPTO_HELPER = "get-crypto-helper"
export const ENABLE_HTTP_HANDLER = "enable_http_handler";
export const DISABLE_HTTP_HANDLER = "disable_http_handler";
export const GET_AUTH_URL = "get_auth_url";
export const REQUEST_ACCESS_TOKEN = "request_get_token";
export const IS_AUTHENTICATED = "is_authenticated";
export const GET_SIGN_OUT_URL = "get_sign_out_url";
export const REFRESH_ACCESS_TOKEN = "refresh_access-token";
export const REFRESH_ACCESS_TOKEN_ERR0R = "refresh-access-token-error";
export const SET_SESSION_STATE = "set_session_state";
export const START_AUTO_REFRESH_TOKEN = "start_auto_refresh_token";
export const UPDATE_CONFIG = "update_config";
export const GET_ID_TOKEN = "get_id_token";
export const CHECK_SESSION_SIGNED_IN = "check_session_signed_in";
export const CHECK_SESSION_SIGNED_OUT = "check_session_signed_out";
export const GET_CONFIG_DATA = "get_config_data";
export const SET_SESSION_STATE_FROM_IFRAME = "set_session_state_from_iframe";
